<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-button type="primary" icon="plus" @click="addCurrency">增加积分配置</el-button>
            </el-col>

        </el-row>
        <el-table :data="currencyList" :height="wheight-160" v-loading="loading">
            <el-table-column prop="id" label="id"></el-table-column>
            <el-table-column prop="yw_name" label="业务名称"></el-table-column>
            <el-table-column prop="params" label="调用参数配置"></el-table-column>
            <el-table-column prop="every_day_max" label="每人派送积分最大量"></el-table-column>
            <el-table-column prop="createtime" label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createtime | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="updatetime" label="更新时间">
                <template slot-scope="scope">
                    <span>{{scope.row.updatetime | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                </template>
            </el-table-column>

            <el-table-column prop="enable_flag" label="是否启用">
                <template slot-scope="scope">
                    <el-switch  v-model="scope.row.enable_flag" :disabled="scope.row.enable_flag ? true : false" ></el-switch>
                </template>
            </el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editAction(scope.$index, scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
            <el-pagination
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page.sync="params.page"
                    :total="total_count" :page-size="params.pageSize">
            </el-pagination>
        </div>
        <!-- 添加、编辑标识-开始 -->
        <el-dialog :title="editTitle" :visible.sync="editVisible"  :before-close="handleCancel">
            <template>
                <el-form ref="form" :model="form"  class="demo-ruleForm" label-width="220px">
                    <el-form-item label="业务名称" prop="yw_name">
                        <el-col :span="20"><el-input required v-model="form.yw_name" placeholder="业务名称 如 看视频送积分"></el-input></el-col>
                    </el-form-item>
                    <el-form-item label="调用参数配置" prop="params">
                        <el-col :span="20" v-if="editflag">
                            <el-input disabled v-model="form.params" placeholder="拼音格式 如 kspsjf 推荐设置为业务名称的拼音,不可修改"></el-input>
                        </el-col>
                        <el-col :span="20" v-else>
                            <el-input required v-model="form.params" placeholder="拼音格式 如 kspsjf 推荐设置为业务名称的拼音,不可修改"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="业务说明" prop="yw_desc">
                        <el-col :span="20"><el-input required v-model="form.yw_desc" placeholder="业务说明"></el-input></el-col>
                    </el-form-item>
                    <el-form-item label="每天每人派送积分最大量" prop="every_day_max" type="number">
                        <el-col :span="50"><el-input required v-model="form.every_day_max" placeholder="每天每人派送积分最大量"></el-input></el-col>
                    </el-form-item>
                    <el-form-item label="是否启用" prop="enable_flag">
                        <el-switch v-model="form.enable_flag" :width="50" active-value='true' inactive-value='false' active-text="开启" inactive-text="关闭" active-color="#13ce66"></el-switch>
                    </el-form-item>
                </el-form>
            </template>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="handleCancel">取消</el-button>
                <el-button type="primary" @click="submitAction">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { Message } from 'element-ui'
    import {getNpPointSetting,createNpPointSetting,updateNpPointSetting } from '../../../../api/point'
    export default {
        data () {
            return {
                dynamicShopName: [],
                dynamicStoreName: [],
                inputVisible: false,
                inputStoreVisible: false,
                inputValue: '',
                editVisible: false,
                editflag:false,
                editTitle: '',
                form: {
                    yw_name: '',
                    params: '',
                    yw_desc: '',
                    every_day_max: '',
                    enable_flag: 'false',
                },
                activeName: 'first',
                currencyList: [],
                detailData: {},
                loading: false,
                total_count: 0,
                params: {
                    page: 1,
                    pageSize: 20,
                    currency: '',
                },
                id: 0,
                // rules:{
                //     yw_name :[{required: true, message: '请输入', trigger: 'blur'}],
                //     yw_desc :[{required: true, message: '请输入', trigger: 'blur'}],
                //     params :[{required: true, message: '请输入', trigger: 'blur'}],
                //     every_day_max :[{required: true, message: '请输入', trigger: 'blur'}]
                // }
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            handleCancel () {
                this.editVisible = false
                this.editflag = false
                this.form.yw_name = ''
                this.form.yw_desc = ''
                this.form.params = ''
                this.form.every_day_max = ''
                this.form.enable_flag = 'false'
                this.id = ''
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getCurrencytListData()
            },
            addCurrency () { // 添加物料弹框
                this.editTitle = '添加积分配置信息'
                this.editVisible = true
                this.editflag = false
                this.form.yw_name = ''
                this.form.yw_desc = ''
                this.form.params = ''
                this.form.every_day_max = ''
                this.form.enable_flag = 'false'
                this.id = ''
            },
            editAction (index, row) { // 编辑物料弹框
                console.log(row)
                console.log(row.enable_flag)
                this.editTitle = '编辑积分配置信息'
                this.editVisible = true
                this.editflag = true
                this.form.yw_name = row.yw_name
                this.form.yw_desc = row.yw_desc
                this.form.params = row.params
                this.form.every_day_max = row.every_day_max
                this.form.enable_flag = row.enable_flag ? 'true' : 'false'
                this.id = row.id
            },
            submitAction () { // 提交物料
                if (!this.form.yw_name || !this.form.params || !this.form.every_day_max || !this.form.yw_desc) {
                    this.$message({
                        type: 'error',
                        message: '请填写全部表单数据'
                    })
                    return
                }

                if(this.id) {
                    updateNpPointSetting(this.id, this.form).then(response => {
                        this.detailData = response.data.data
                        this.editVisible = false
                        this.getCurrencytListData()
                        this.handleCancel()
                    })
                } else {
                    createNpPointSetting(this.form).then(response => {
                        this.detailData = response.data.data
                        this.editVisible = false
                        this.getCurrencytListData()
                        this.handleCancel()
                    })
                }
            },
            dataSearch() {
                this.params.page = 1
                this.getCurrencytListData()
            },
            getCurrencytListData () {
                this.loading = true
                getNpPointSetting(this.params).then(response => {
                    this.currencyList = response.data.data.list
                    this.total_count = response.data.data.total_count
                    this.loading = false
                })
            },
            deleteAction (index, row) {
                this.$confirm('此操作将删除该账号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCurrencyInfo(row.id).then(response => {
                        this.currencyList.splice(index, 1)
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 5 * 1000
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            setDefault (row) {
                setDefaultCurrency(row.id).then(response => {
                    this.getCurrencytListData()
                })
            }

        },
        mounted () {
            console.log(111111);
            this.getCurrencytListData()
        }
    }
</script>
<style scoped lang="scss">
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .new-tag {
        height: 40px;
        line-height: 40px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .button-new-tag {
        height: 40px;
        line-height: 40px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        height: 40px;
        line-height: 40px;
        width:138px;
        vertical-align: bottom;
    }

    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 10px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>



// WEBPACK FOOTER //
// index.vue?57ea0c09